import { render, staticRenderFns } from "./SettingsView.vue?vue&type=template&id=685556f7&scoped=true&lang=pug&"
import script from "./SettingsView.vue?vue&type=script&lang=ts&"
export * from "./SettingsView.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsView.vue?vue&type=style&index=0&id=685556f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685556f7",
  null
  
)

export default component.exports